// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog .single-blog {
  position: relative;
  text-decoration: none;
  color: #000000;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1607843137);
}
.blog .single-blog:hover {
  background: #ffffff;
}
.blog .single-blog .card-img-top {
  border-radius: 0.25rem;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
}
.blog .single-blog .blog-title {
  font: normal normal normal 18px/20px "proxima-nova";
  letter-spacing: 0px;
  color: #142031;
}
@media screen and (min-width: 530px) {
  .blog .single-blog .blog-title {
    min-height: 50px;
  }
}
.blog .single-blog .blog-time {
  position: absolute;
  font: normal normal normal 13px/12px "Roboto", sans-serif;
  letter-spacing: 0px;
  color: #707070;
  right: 8px;
  bottom: 8px;
}
.blog .single-blog .content {
  position: relative;
}
.blog .single-blog .content .post-time {
  text-transform: uppercase;
}
.blog .single-blog .content .post-time,
.blog .single-blog .content p {
  font: normal normal normal 14px/12px "Roboto", sans-serif;
  letter-spacing: 0px;
  color: #707070;
}
.blog .single-blog .content p {
  margin-bottom: 1rem;
}
.blog .pagination-block {
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1607843137);
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/blog/_blog.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mDAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,sBAAA;EACA,oDAAA;AADN;AAII;EACE,mDAAA;EACA,mBAAA;EACA,cAAA;AAFN;AAGM;EAJF;IAKI,gBAAA;EAAN;AACF;AAGI;EACE,kBAAA;EACA,yDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AADN;AAGI;EACE,kBAAA;AADN;AAEM;EACE,yBAAA;AAAR;AAEM;;EAEE,yDAAA;EACA,mBAAA;EACA,cAAA;AAAR;AAEM;EACE,mBAAA;AAAR;AAIE;EACE,mDAAA;AAFJ","sourcesContent":[".blog {\n  .single-blog {\n    position: relative;\n    text-decoration: none;\n    color: #000000;\n    box-shadow: 0px 3px 4px #00000029;\n\n    &:hover {\n      background: #ffffff;\n    }\n\n    .card-img-top {\n      border-radius: 0.25rem;\n      box-shadow: 0px 3px 20px #00000029;\n    }\n\n    .blog-title {\n      font: normal normal normal 18px/20px \"proxima-nova\";\n      letter-spacing: 0px;\n      color: #142031;\n      @media screen and (min-width: 530px) {\n        min-height: 50px;\n      }\n    }\n\n    .blog-time {\n      position: absolute;\n      font: normal normal normal 13px/12px \"Roboto\", sans-serif;\n      letter-spacing: 0px;\n      color: #707070;\n      right: 8px;\n      bottom: 8px;\n    }\n    .content {\n      position: relative;\n      .post-time {\n        text-transform: uppercase;\n      }\n      .post-time,\n      p {\n        font: normal normal normal 14px/12px \"Roboto\", sans-serif;\n        letter-spacing: 0px;\n        color: #707070;\n      }\n      p {\n        margin-bottom: 1rem;\n      }\n    }\n  }\n  .pagination-block {\n    box-shadow: 0px 3px 4px #00000029;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
